import Axios from "axios";
import {
    SET_TAX_SUMMARY_REPORT_LIST, 
    UNSET_TAX_SUMMARY_REPORT_LIST
} from "@/store/mutation-types";
import {
    getTaxSummaryReport,
} from "@/store/api";

const state = {
    getTaxSummaryReport: [],
};

const getters = {
    getTaxSummaryReport(state) {
        return state.getTaxSummaryReport;
    },
};

const mutations = {
    [SET_TAX_SUMMARY_REPORT_LIST](state, data) {
        state.getTaxSummaryReport = data;
    },
    [UNSET_TAX_SUMMARY_REPORT_LIST](state) {
        state.getTaxSummaryReport = [];
    },
};

const actions = {

    getTaxSummaryReport({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${getTaxSummaryReport}`, { params: data })
                .then((response) => {
                    commit(SET_TAX_SUMMARY_REPORT_LIST, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_TAX_SUMMARY_REPORT_LIST);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
    

};


export default {
    state,
    getters,
    actions,
    mutations,
};